// Mock data for JM Guru - Jedrek Magdalena Sports & Governance Advisor

export const heroImages = [
  "/images/IMG_8034.jpeg",
  "/images/IMG_6334.jpeg",
  "/images/IMG_8727.jpeg",
  "/images/IMG_5069.jpeg",
  "/images/IMG_1508.jpeg",
  "/images/IMG_0323.jpeg",
  "/images/IMG_6193.jpeg",
  "/images/IMG_1149.jpeg",
  "/images/IMG_8124.jpeg",
  "/images/IMG_2379.jpeg",
  "/images/IMG_0446.jpeg",
  "/images/IMG_1579.jpeg",
];

export const aboutPillars = [
  {
    id: 1,
    title: "Focus",
    description: "I operate where sports, governance, and leadership intersect — delivering systems that align performance with strategy and measurable outcomes.",
    image: "/images/IMG_6193.jpeg"
  },
  {
    id: 2,
    title: "Network",
    description: "A cultivated network of federations, government officials, sponsors, and operators who share a commitment to elevating sport as a strategic tool.",
    image: "/images/IMG_1149.jpeg"
  },
  {
    id: 3,
    title: "Partnership",
    description: "I work alongside founders, federations, and executives — often before the vision is fully defined — providing structure, credibility, and execution.",
    image: "/images/f2747439-936f-44e5-b9d5-09efdd44e910.jpeg"
  }
];

export const services = [
  {
    id: 1,
    category: "Guidance & Motivation",
    title: "Performance Begins Within",
    description: "I guide athletes, executives, and ambitious individuals to build mental resilience, discipline systems, strategic clarity, emotional control, and long-term vision. Motivation is temporary. Structure creates transformation.",
    tags: ["Mental Resilience", "Discipline Systems", "Strategic Clarity"],
    image: "/images/guidance-motivation.webp"
  },
  {
    id: 2,
    category: "Sports & Government",
    title: "Where Sport Meets Policy",
    description: "I operate between federations, ministries, leagues, teams and sponsors — aligning sport with policy, funding, and national development. Sport is competition — and a strategic economic tool.",
    tags: ["National Strategy", "Governance", "Funding Frameworks"],
    image: "https://images.unsplash.com/photo-1606037988094-fbc91ebdcdfb?w=600&h=400&fit=crop"
  },
  {
    id: 3,
    category: "Strategy & Execution",
    title: "Vision Without Execution is Noise",
    description: "I design and lead high performance projects, international tournaments, sports tourism initiatives, and sponsorship architecture. Every project built on KPIs, accountability, and measurable outcomes.",
    tags: ["Strategic Roadmaps", "International Tournaments", "Sponsorship Architecture"],
    image: "https://images.unsplash.com/photo-1546519638-68e109498ffc?w=600&h=400&fit=crop"
  },
  {
    id: 4,
    category: "Vision & Measurable Results",
    title: "Ambition Must Be Measurable",
    description: "I translate vision into growth strategies, revenue expansion models, sustainable development pathways, and organizational restructuring. If it can't be measured, it can't improve.",
    tags: ["Growth Strategies", "Revenue Models", "Organizational Restructuring"],
    image: "https://images.unsplash.com/photo-1460925895917-afdab827c52f?w=600&h=400&fit=crop"
  }
];

export const membershipBenefits = [
  {
    title: "Monthly Performance Brief",
    items: ["Leadership frameworks", "Discipline systems", "Mental strength", "Strategic decision-making", "Financial mindset", "High-performance habits"]
  },
  {
    title: "Exclusive Resources",
    items: ["Private strategy notes", "Leadership templates", "Performance checklists", "Digital tools", "Early access to events & products"]
  },
  {
    title: "Priority Access",
    items: ["Coaching priority", "Private session invitations", "Member-only opportunities"]
  }
];

export const whoIWorkWith = [
  "Sports federations",
  "Government ministries",
  "Professional teams & leagues",
  "Corporate sponsors",
  "Executives & emerging leaders",
  "High-standard individuals",
  "Athletes",
  "People who are ready to grow"
];

export const whyWorkWithMe = [
  "Business intelligence",
  "Strategy + execution",
  "Discipline + measurable outcomes",
  "Long-term vision + operational control"
];

export const newsArticles = [
  {
    id: 1,
    category: "Strategy",
    title: "Why Governance is the Hidden Engine of Elite Sport",
    date: "June 12, 2025",
    excerpt: "Federations that invest in governance infrastructure consistently outperform those that don't. Here's the framework I apply across every engagement.",
    readTime: "5 min read"
  },
  {
    id: 2,
    category: "Leadership",
    title: "The Discipline Gap: What Separates Good Leaders from Great Ones",
    date: "May 28, 2025",
    excerpt: "Discipline isn't about working harder. It's about building systems that make the right decision automatic. This is how I coach executive performance.",
    readTime: "4 min read"
  },
  {
    id: 3,
    category: "Sports & Government",
    title: "Aligning Sport Policy with National Development Goals",
    date: "April 15, 2025",
    excerpt: "When ministries and federations speak the same strategic language, results compound. A blueprint for integrated sport-government alignment.",
    readTime: "6 min read"
  }
];

export const galleryImages = [
  "/images/IMG_8034.jpeg",
  "/images/IMG_0323.jpeg",
  "/images/IMG_8727.jpeg",
  "/images/IMG_1149.jpeg",
  "/images/23a20b83-7526-481f-87f0-f495808e0744.jpeg",
  "/images/ee477888-6f80-4bdf-ab4b-310a1655e921.jpeg",
  "/images/991d25eb-9c6b-430c-9598-06f5781bb4e1.jpeg",
  "/images/IMG_8124.jpeg",
];
